
import { ForgotPasswordComponent } from './resetPassword/forgotPassword.component';
import { CancelPageComponent } from './claimprocess/cancelPage.component';


import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { AppRoutingModule } from './routes'
import { CoreModule } from '@wgu-edu/wgu-core';
import { environment } from 'src/environments/environment';
import { HttpClientModule } from '@angular/common/http'

import { IIQExternalAppComponent } from './iiq-external-app.component'
import { NavBarComponent } from './nav/nav-bar.component'
import { ClaimProcessComponent } from './claimprocess/claimProcess.component'
import { SecurityQuestionListComponent } from './claimprocess/securityQuestions.component';
import { SecurityQuestionsService } from './claimprocess/service/securityQuestions.service';

import { SetUpPasswordComponent } from './claimprocess/setUpPassword.component'
import { LoginClaimProcessComponent } from './claimprocess/loginClaimProcess.component'
import { SuccessComponent } from './claimprocess/success.component';
import { BehaviorSubject } from 'rxjs';
import { BehavioralService } from './claimprocess/service/behavioral.service';
import { ClaimService } from './claimprocess/service/claim.service';
import { AuthenticationQuestionsService } from './resetPassword/service/authenticationQuestions.service';
import { ResetPasswordComponent } from './resetPassword/resetPassword.component';
import { SetUpPasswordService } from './claimprocess/service/setUpPassword.service';
import { EnvServiceProvider} from './services/env.service.provider';
import { WorkflowServiceProvider } from './services/workflow.service.provider';
import { UsernameAccount } from './updateAccount/usernameAccount.component';
import { FormSelectComponent } from './shared/form-select/form-select.component';
import { ValidateSecurityQuestions } from './resetPassword/validateQuestions.component'

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    CoreModule.forRoot(environment)
  ],
  declarations: [
    IIQExternalAppComponent,
    NavBarComponent,
    ClaimProcessComponent,
    LoginClaimProcessComponent,
    SetUpPasswordComponent,
    CancelPageComponent,
    SuccessComponent,
    SecurityQuestionListComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    UsernameAccount,
    FormSelectComponent,
    ValidateSecurityQuestions
  ],
  providers: [
    SecurityQuestionsService,
    BehavioralService,
    ClaimService,
    SetUpPasswordService,
    AuthenticationQuestionsService,
    EnvServiceProvider,
    WorkflowServiceProvider,
    ForgotPasswordComponent
  ],
  bootstrap: [IIQExternalAppComponent]
})
export class AppModule {}


